import { Box } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { ApplicationInputStyle } from "../../constants";

const ApplyRequiredError = ({ field, msg }) => {
  const apply = useSelector((state) => state.apply);
  if (apply.missing.includes(field)) {
    return <Box sx={ApplicationInputStyle.error}>{msg}</Box>;
  }
  return null;
};

export default ApplyRequiredError;
